module.exports = __webpack_public_path__ + "img/Capitec-Logo.92db9f55.svg";